$(function () {
  $('.full-image-content-block-gallery').modal();
});



// WEBPACK FOOTER //
// ./assets/js/components/layout/full-width-components.js